import { render, staticRenderFns } from "./recActLogs.vue?vue&type=template&id=188563f8&scoped=true&"
import script from "./recActLogs.vue?vue&type=script&lang=js&"
export * from "./recActLogs.vue?vue&type=script&lang=js&"
import style0 from "./recActLogs.vue?vue&type=style&index=0&id=188563f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188563f8",
  null
  
)

export default component.exports